import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import {
  ClearCurrentResource,
  SetCurrentResource,
  SetFormViolations,
  SetOnlineStatus,
  SetRouteData
} from '~backoffice/app/~store/actions/global.actions';
import { GlobalState } from '~backoffice/app/~store/states/global.state';
import { Observable } from 'rxjs';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import {
  FormViolation,
  GlobalRouteData,
  Resource
} from '~core/models/shared.models';

@Injectable()
export class GlobalFacade {
  protected _store = inject(Store);

  routeData$ = this._store.select(GlobalState.routeData);

  @SelectSnapshot(GlobalState.routeData) routeData!: ReturnType<
    typeof GlobalState.routeData
  >;

  params$ = this._store.select(GlobalState.params);

  @SelectSnapshot(GlobalState.params) params!: ReturnType<
    typeof GlobalState.params
  >;

  queryParams$ = this._store.select(GlobalState.queryParams);

  @SelectSnapshot(GlobalState.queryParams) queryParams!: ReturnType<
    typeof GlobalState.queryParams
  >;

  formViolations$ = this._store.select(GlobalState.formViolations);

  @SelectSnapshot(GlobalState.formViolations) formViolations!: ReturnType<
    typeof GlobalState.formViolations
  >;

  isDeviceOnline$ = this._store.select(GlobalState.isDeviceOnline);

  currentResource$ = this._store.select(GlobalState.currentResource);

  @SelectSnapshot(GlobalState.currentResource) currentResource!: ReturnType<
    typeof GlobalState.currentResource
  >;

  @SelectSnapshot(GlobalState.isDeviceOnline) isDeviceOnline!: ReturnType<
    typeof GlobalState.isDeviceOnline
  >;

  // Action Dispatchers
  setRouteData(data: GlobalRouteData): Observable<unknown> {
    return this._store.dispatch(new SetRouteData(data));
  }

  setFormViolations(data: FormViolation[] | undefined): Observable<unknown> {
    return this._store.dispatch(new SetFormViolations(data));
  }

  setCurrentResource(data: Resource | undefined): Observable<unknown> {
    return this._store.dispatch(new SetCurrentResource(data));
  }

  clearCurrentResource(): Observable<void> {
    return this._store.dispatch(new ClearCurrentResource());
  }

  handleFormViolations(
    error: HttpErrorResponse,
    fields?: Record<string, unknown>,
    emitDefault?: boolean
  ): Observable<unknown> | undefined {
    let violations = error.error?.violations as FormViolation[] | undefined;
    if (fields && violations) {
      violations = violations.filter(el =>
        Object.keys(fields).some(field => el.propertyPath.includes(field))
      );
    }
    if (!violations?.length && emitDefault) {
      violations = [
        {
          propertyPath: 'noKey',
          title:
            error.error?.detail ||
            `Une erreur s'est produite. Veuillez réessayer plus tard`,
          type: ''
        }
      ];
    }
    if (violations?.length) {
      return this.setFormViolations(violations);
    }
    return;
  }

  setOnlineStatus(
    ...data: ConstructorParameters<typeof SetOnlineStatus>
  ): Observable<unknown> {
    return this._store.dispatch(new SetOnlineStatus(...data));
  }
}
